import React from "react";
import { Trans } from "react-i18next";

import { Footer, FooterLink } from "./CaptchaDisclaimer.style";

export const CaptchaDisclaimer = ({ isFormActive }) => {
  return (
    <Footer className="hcaptcha-footer" data-testid="hcaptcha-footer" isFormActive={isFormActive}>
      <Trans
        i18nKey="Footer.Hcaptcha.PrivacyPolicy"
        components={{
          1: <FooterLink href="https://www.hcaptcha.com/privacy" target="_blank" rel="noopener noreferrer" />,
          2: <FooterLink href="https://www.hcaptcha.com/terms" target="_blank" rel="noopener noreferrer" />
        }}
      />
    </Footer>
  );
};
